"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var i18n = _interopRequireWildcard(require("I18n"));

var _setDocumentTitle = _interopRequireDefault(require("I18n/utils/setDocumentTitle"));

var _q = _interopRequireDefault(require("q"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _ravenHubspot = require("raven-hubspot");

var _urls = require("settings-ui-sdk/utils/urls");

var _reactRedux = require("react-redux");

var _configureStore = _interopRequireDefault(require("./utils/configureStore"));

var _reactRouter = require("react-router");

var _reactRouterRedux = require("react-router-redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _history = require("history");

var _Routes = _interopRequireDefault(require("./Routes"));

var _Routes2 = _interopRequireDefault(require("ContentUtils/Routes"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _usageTracker = _interopRequireDefault(require("settings-ui-sdk/utils/usageTracker"));

var _usageTrackerRedux = require("usage-tracker-redux");

var _UIApplication = _interopRequireDefault(require("UIComponents/app/UIApplication"));

var _NotificationMiddleware = _interopRequireDefault(require("ReduxMessenger/middleware/NotificationMiddleware"));

var _reactRhumb = require("react-rhumb");

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

var _historyAdapterV = _interopRequireDefault(require("react-rhumb/historyAdapterV3"));

// Redux
// Configure the router
// Monitoring and Performance
// Notifications
var Application =
/*#__PURE__*/
function () {
  function Application(rootModule, name) {
    (0, _classCallCheck2.default)(this, Application);
    this.rootModule = rootModule;
    this.name = name;
  } // Kicks off the app. This is intentionally not in the constructor just in
  // case there is a reason you need to explicitly call init (and don't want it
  // auto-called by importing this module)


  (0, _createClass2.default)(Application, [{
    key: "start",
    value: function start() {
      _hubspot.default.get();

      if (window.jasmine) return;
      window.AppInstance = this;
      this.init().done();
    } // Performs all the initialization needed before the main app code can run/render.

  }, {
    key: "init",
    value: function init() {
      var _this = this;

      return _q.default.Promise.all([this.auth(), i18n.Info]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
            authConfig = _ref2[0];

        _this.authConfig = authConfig;

        _Routes2.default.init(authConfig.gates);

        _this.setRavenUserContext();

        _this.startReduxAndRouter();
      });
    }
  }, {
    key: "auth",
    value: function auth() {
      return (0, _userInfo.default)().then(function (_ref3) {
        var portal = _ref3.portal,
            gates = _ref3.gates,
            user = _ref3.user;
        (0, _ravenHubspot.setUserContext)(user);
        return {
          portal: portal,
          gates: gates,
          user: user
        };
      }).catch(function (error) {
        if (error.message !== 'Aborting: redirection in progress') {
          throw error;
        }
      });
    }
  }, {
    key: "startReduxAndRouter",
    value: function startReduxAndRouter() {
      var browserHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
        basename: (0, _urls.getRootUrl)()
      });
      var middleware = [(0, _reactRouterRedux.routerMiddleware)(browserHistory), (0, _usageTrackerRedux.usageTrackerMiddleware)(_usageTracker.default), _NotificationMiddleware.default, _reduxThunk.default];
      this.store = (0, _configureStore.default)({
        auth: this.authConfig
      }, this.rootModule, middleware);
      this.history = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, this.store);
      (0, _setDocumentTitle.default)('settingsui.tabTitle');
      (0, _reactDom.render)(_react.default.createElement(_UIApplication.default, {
        name: this.name
      }, _react.default.createElement(_reactRedux.Provider, {
        store: this.store
      }, _react.default.createElement(_reactRhumb.RhumbProvider, {
        history: (0, _historyAdapterV.default)(this.history),
        config: _rhumbConfig.default
      }, _react.default.createElement(_reactRouter.Router, {
        history: this.history
      }, (0, _Routes.default)({
        rootModule: this.rootModule,
        scopes: this.authConfig.user.scopes,
        gates: this.authConfig.gates
      }))))), document.getElementsByClassName('page')[0]);
    }
  }, {
    key: "setRavenUserContext",
    value: function setRavenUserContext() {
      var user = this.authConfig.user;
      var fullName = user.first_name + " " + user.last_name;
      var email = user.email;

      var portalId = _hubspot.default.get();

      if (window.Raven && typeof window.Raven.setUserContext === 'function') {
        window.Raven.setUserContext({
          name: fullName,
          email: email,
          portalId: portalId
        });
      }
    }
  }]);
  return Application;
}();

exports.default = Application;
module.exports = exports.default;